import React, { useContext, useEffect, useState } from "react";
import "./Wishlist.css";
import Common_breadcrumb from "../common_components/common_breadcrumb/Common_breadcrumb";
import Common_Heading from "../common_components/common_Heading/Common_Heading";
import Product_add_to_cart_card from "../common_components/product_add_to_cart_card/Product_add_to_cart_card";
import { getWishlist } from "../../utils/luxuryapis/Wishlist/Wishlist";
import { Context } from "../../utils/context";
import { encodeId } from "../../utils/common";

function Wishlist() {
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "Wishlist" },
  ];
  const { IMG_URL } = useContext(Context);
  const [isWishlisted, setIsWishlisted] = useState([]);
  const getWishlists = async () => {
    try {
      const res = await getWishlist();
      const wishlist = res?.data;
      setIsWishlisted(wishlist);
    } catch (error) {
      console.error("Failed to fetch wishlist:", error);
    }
  };

  useEffect(() => {
    getWishlists();
  }, []);
  return (
    <>
      <section className="Wishlist">
        <div className="custom_container">
          <Common_breadcrumb items={breadcrumbItems} />
          {isWishlisted && isWishlisted.length > 0 ? (
            <>
              <div className="heading_holder">
                <Common_Heading
                  headingText={"Wishlist"}
                  subHeadingText={"You never want to miss"}
                />
              </div>

              <div className="wishliast_cads_holder">
                <div className="row">
                  {isWishlisted.map((val, index) => (
                    <div
                      className="col-xl-3 col-md-4 col-sm-6 mb-3"
                      key={index}
                    >
                      <Product_add_to_cart_card
                        getDataWishlists={getWishlists}
                        isWishlisted={isWishlisted}
                        product={val?.product}
                        id={val?.product?.id}
                        image={IMG_URL + val?.product?.image1}
                        url={`/luxury/product-details/${encodeId(
                          val?.product?.id,
                        )}`}
                        title={val?.product?.name}
                        mrp={
                          val?.product?.product_variants?.[0]
                            ?.product_quantities?.[0]?.mrp
                        }
                        selling_price={
                          val?.product?.product_variants?.[0]
                            ?.product_quantities?.[0]?.price
                        }
                        discount={
                          val?.product?.discount ||
                          (val?.product?.product_variants?.[0]
                            ?.product_quantities?.[0]?.price > 0
                            ? Math.round(
                                ((val?.product?.product_variants?.[0]
                                  ?.product_quantities?.[0]?.mrp -
                                  val?.product?.product_variants?.[0]
                                    ?.product_quantities?.[0]?.price) /
                                  val?.product?.product_variants?.[0]
                                    ?.product_quantities?.[0]?.mrp) *
                                  100,
                              )
                            : 0)
                        }
                      />
                    </div>
                  ))}

                  {/* <div className="col-xl-3 col-md-4 col-sm-6 mb-3">
                <Product_add_to_cart_card />
              </div>

              <div className="col-xl-3 col-md-4 col-sm-6 mb-3">
                <Product_add_to_cart_card />
              </div>

              <div className="col-xl-3 col-md-4 col-sm-6 mb-3">
                <Product_add_to_cart_card />
              </div> */}
                </div>
              </div>
            </>
          ) : (
            <div className="col-12 text-center py-5">
              <div style={{ fontSize: "50px" }}>💖</div>
              <h5>No Wishlist Items</h5>
              <p style={{ color: "#777" }}>
                Your wishlist is empty. Start adding products you love.
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default Wishlist;
